// utils/optionUtils.js

/**
 * Maps a form value to its corresponding text from optionData.
 *
 * @param {Array} optionData - Array of option groups with optionName and values.
 * @param {string} optionName - The specific option group name to look into.
 * @param {string} value - The value to match inside the values array.
 * @returns {string} - The corresponding text if found, otherwise an empty string.
 */
export function getOptionText(optionData, optionName, value) {
  const options = optionData.find((opt) => opt.optionName === optionName)?.values || [];
  const matched = options.find((item) => item.optionValue === value);
  return matched?.optionText || "";
}



/**
 * Finds the `value` that corresponds to the given `text` in optionData.
 *
 * @param {Array} optionData - Array of option groups with optionName and values.
 * @param {string} optionName - The group name to search inside.
 * @param {string} text - The display text to match.
 * @returns {string} - The matched value, or an empty string if not found.
 */
export function getOptionValueByText(optionData, optionName, text) {
  const options = optionData.find((opt) => opt.optionName === optionName)?.values || [];
  const matched = options.find((item) => item.optionText === text);
  return matched?.optionValue || "";
}

export function convertTermDepositsToOptionData(termDeposits) {
  return {
    optionName: "fkTermDepositId",
    values: termDeposits.map(td => ({
      id: td.id,
      optionValue: td.id,
      optionText: `${td.depositName} (${td.depositType})`,
      // optional extra fields for convenience:
      depositCode: td.depositCode,
      depositType: td.depositType,
      depositFrequency: td.depositFrequency,
      minDepositDuration: td.minDepositDuration,
      maxDepositDuration: td.maxDepositDuration,
      minDepositAmount: td.minDepositAmount,
      maxDepositAmount: td.maxDepositAmount,
      interestRate: td.interestRate,
      interestFrequency: td.interestFrequency,
      interestType: td.interestType,
      onLoanExtraInterestRate: td.onLoanExtraInterestRate,
      onLoanMaxInterestDep: td.onLoanMaxInterestDep,
      remarks: td.remarks,
      selected: false
    }))
  };
}

export function toOptionData(data, keyName, id, valueName, textName, dataName) {
  return {
    optionName: keyName,
    values: data.map(opt => ({
      id: opt[id],
      optionValue: opt[valueName],
      optionText: opt[textName],
      data: opt[dataName]
    }))
  };
}
